import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useRothkoFetcher } from "web/react/hooks/use-rothko-fetcher";
import {
    setRetailerInformation,
    setRetailerInformationLoading,
} from "web/redux/ducks/retailer-information";
import { RetailerInformation } from "web/types/serializers";

interface UseFetchRetailerInfoResults {
    fetchRetailerInfo: (retailerSlug: string) => Promise<void>;
}

export function useFetchRetailerInfo(): UseFetchRetailerInfoResults {
    const dispatch = useDispatch();

    const [fetch] = useRothkoFetcher<RetailerInformation>(
        "modules/retailer_information",
        undefined,
        true
    );

    const fetchRetailerInfo = useCallback(
        async function (retailerSlug: string): Promise<void> {
            dispatch(setRetailerInformationLoading(true));
            const retailerInformation = await fetch({ retailer_slug: retailerSlug });

            if (retailerInformation) {
                dispatch(setRetailerInformation(retailerInformation));
            }
        },
        [fetch, dispatch]
    );

    return { fetchRetailerInfo };
}
